import {Box, Heading5, styled, Body2} from '../../../ui-library';

export const ContainerBox = styled(Box)`
    padding: 73px 101px 25px 101px;
    background: ${({ theme }) => theme.palette.grey[900]};
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: auto;
    box-sizing: border-box;
`;


export const ContainerBoxWrong = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
`;

export const TitleWrong = styled(Heading5)`
    font-weight: 700;
    color: #FFFFFF;
`;

export const SubTitleWrong = styled(Body2)`
    color: #FFFFFF;
    margin-top: 15px;
`;


export const ResponsiveBox = styled(Box)`
    display: flex;
    justify-content: space-between;
    gap: 53px;
`;
